var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAcademiesModuleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 2,
    fill: "#014337"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.507 15.5001H17.25V7.33341C17.25 7.024 17.1271 6.72725 16.9083 6.50846C16.6895 6.28966 16.3928 6.16675 16.0833 6.16675H8.5C7.7965 6.16675 6.75 6.63283 6.75 7.91675V16.0834C6.75 17.3673 7.7965 17.8334 8.5 17.8334H17.25V16.6667H8.507C8.2375 16.6597 7.91667 16.553 7.91667 16.0834C7.91667 15.6138 8.2375 15.5071 8.507 15.5001ZM9.66667 8.50008H14.9167V9.66675H9.66667V8.50008Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcademiesModuleIcon);
export default __webpack_public_path__ + "static/media/academies-module-icon.afe587a65e30cd3085e846fc9a3ae3a1.svg";
export { ForwardRef as ReactComponent };